export default {
  state: {
    dataTooth: {
      number: null,
      zone: null,
    },
    toothStates: [],
    dataDientes: [],
  },

  mutations: {
//    updateRealizadoByToken(state, { token, realizado, fecha }) {
//   state.dataDientes.forEach((diente, index) => {
//     const zonas = diente.zonaProcedimiento || {};

//     for (const zona in zonas) {
//       const detalle = zonas[zona];
//       if (detalle && detalle.token === token) {
//         // ⚠️ Reemplazamos el objeto zona para asegurar reactividad
//         state.dataDientes[index].zonaProcedimiento = {
//           ...zonas,
//           [zona]: {
//             ...detalle,
//             realizado,
//             fecha_realizacion: fecha,
//           },
//         };
//       }
//     }
//   });
// },

updateRealizadoByToken(state, { token, realizado, fecha }) {
  for (const diente of state.dataDientes) {
    if (!diente.zonaProcedimiento) continue;

    for (const zona in diente.zonaProcedimiento) {
      const detalle = diente.zonaProcedimiento[zona];

      if (detalle && detalle.token === token) {

        
        // Solo actualizamos directamente la zona afectada
        diente.zonaProcedimiento[zona] = {
          ...detalle,
          realizado : realizado,
          fecha_realizacion: fecha,
        };
        return; // ✅ Ya lo encontramos, salimos
      }
    }
  }
},




    removeZonaProcedimientoByToken(state, token) {
      // Recorremos todos los dientes
      state.dataDientes.forEach((diente) => {
        const zonas = diente.zonaProcedimiento;

        if (!zonas) return;

        for (const zona in zonas) {
          const detalle = zonas[zona];

          // Si encontramos una zona con ese token, la eliminamos
          if (detalle && detalle.token === token) {
            zonas[zona] = null;
          }
        }
      });

      // Limpieza opcional: quitar dientes sin ninguna zona activa
      state.dataDientes = state.dataDientes.filter((diente) => {
        const zonas = diente.zonaProcedimiento || {};
        return Object.values(zonas).some((z) => z !== null);
      });
    },

    addDataDienteProcedimientoAll(state, nuevoDiente) {
  
  const nuevo = { ...nuevoDiente };

  
    nuevo.zonaProcedimiento = {
      all: { ...nuevoDiente.zonaProcedimiento.all },
      arriba: null,
      abajo: null,
      centro: null,
      izquierda: null,
      derecha: null,
    };
  

  // Siempre agrega, sin importar si ya existe uno con el mismo numeroPieza
  state.dataDientes.push(nuevo);
},

    addOrUpdateDataDiente(state, nuevoDiente) {
      const index = state.dataDientes.findIndex(
        (d) => d.numeroPieza === nuevoDiente.numeroPieza
      );

      const procsAllPieza = ["cap", "ext", "cop", "sellante", "end"];
      const esProcedimientoAll = procsAllPieza.includes(
        nuevoDiente.zonaProcedimiento?.all?.procedimiento
      );

      if (index !== -1) {
        const dienteExistente = { ...state.dataDientes[index] };

        if (esProcedimientoAll) {
          // Si es "all", reemplazamos completamente el objeto
          dienteExistente.zonaProcedimiento = {
            all: { ...nuevoDiente.zonaProcedimiento.all },
            arriba: null,
            abajo: null,
            centro: null,
            izquierda: null,
            derecha: null,
          };
        } else {
          // Procedimientos por zona específica
          dienteExistente.zonaProcedimiento = {
            ...dienteExistente.zonaProcedimiento,
            ...nuevoDiente.zonaProcedimiento,
          };
        }

        state.dataDientes.splice(index, 1, dienteExistente);
      } else {
        // Agregar nuevo diente
        const nuevo = { ...nuevoDiente };

        if (esProcedimientoAll) {
          nuevo.zonaProcedimiento = {
            all: { ...nuevoDiente.zonaProcedimiento.all },
            arriba: null,
            abajo: null,
            centro: null,
            izquierda: null,
            derecha: null,
          };
        }

        state.dataDientes.push(nuevo);
      }
    },

    cleanDataDientes(state, value) {
      state.dataDientes = value;
    },

    removeToothState(state, number) {
      state.toothStates = state.toothStates.filter((t) => t.id !== number);
    },

    setDataTooth(state, newData) {
      state.dataTooth = newData;
    },

    removeToothStateByToken(state, token) {
      state.toothStates = state.toothStates.filter((t) => t.token !== token);
    },

    setToothState(state, newData) {
      state.toothStates = [...newData];
    },

    removeToothState(state, id) {
      const index = state.toothStates.findIndex((t) => t.id === id);
      if (index !== -1) {
        state.toothStates.splice(index, 1);
      }
    },

    clearDataTooth(state) {
      state.dataTooth = {
        number: null,
        zone: null,
      };
    },

    clearDataToothState(state) {
      state.toothStates = [];
    },

    clearDataDientes(state) {
      state.dataDientes = [];
    },
  },
};
